<template>
  <apexchart
    title="chart_base"
    :series="store_chart.getSeries('base')"
    :options="{
      chart: { id: 'base', height: 400 },
      yaxis: store_chart.getAxis('base'),
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd/MM'
        }
      },
      stroke: {
        width: store_chart.getStrokes('base')
      },
      title: { text: store_chart.getDevice?.name },
      tooltip: {
        x: {
          show: true,
          format: 'dd/MM HH:mm',
          formatter: undefined
        }
      }
    }"
  />
  <apexchart
    v-if="store_chart.dates.comp"
    title="chart_comp"
    :series="store_chart.getSeries('comp')"
    :options="{
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd/MM'
        }
      },
      chart: { id: 'comp', height: 400 },
      yaxis: store_chart.getAxis('comp')
    }"
  />
</template>

<script setup lang="ts">
import { useChartStore } from '@/stores/store_chart'

const store_chart = useChartStore()
</script>
